import { useState } from 'react';
import { useDispatch } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

const STORE_KEY = 'wc/store/cart';

export const useStoreAddToCart = (productId) => {
    const { createErrorNotice, removeNotice } = useDispatch('core/notices');
    const { addItemToCart } = useDispatch(STORE_KEY);

    const [addingToCart, setAddingToCart] = useState(false);
    const [success, setSuccess] = useState(null);

    const addToCart = (quantity = 1) => {
        setAddingToCart(true);
        return addItemToCart(productId, quantity)
            .then(() => {
                removeNotice('add-to-cart');
                setSuccess(true);
            })
            .catch((error) => {
                createErrorNotice(decodeEntities(error.message), {
                    id: 'add-to-cart',
                    context: 'wc/all-products',
                    isDismissible: true,
                });
                setSuccess(false);
            })
            .finally(() => {
                setAddingToCart(false);
            });
    };

    return {
        addToCart,
        addingToCart,
        success,
    };
};

export default useStoreAddToCart;
